export const getRequestObject = (requestData) => {
  return {
    start_timestamp: requestData.start_timestamp,
    url: requestData.url,
    duration_ms: Math.round(requestData.duration_ms),
  }
}
